import React, { Component } from 'react';
import Select from 'react-select';

import 'react-select/dist/react-select.css';

export default class SelectInput extends Component {
  onChange(event) {
    if (this.props.input.onChange) {
      if (this.props.onChangeCallback) {
        this.props.onChangeCallback(event.value);
      }
      // <-- To be aligned with how redux-form publishes its CHANGE action payload. The event received is an object with 2 keys: "value" and "label"
      this.props.input.onChange(event.value);
    }
  }

  render() {
    return (
      <div className="form_input_select_container">
        { this.props.label ? <label>{ this.props.label }</label> : ''}
        <Select
          {...this.props}
          value={this.props.input.value || ''}
          clearable={false}
          placeholder="Select..."
          onBlur={() => this.props.input.onBlur(this.props.input.value)}
          onChange={this.onChange.bind(this)}
          options={this.props.options} // <-- Receive options from the form
          searchable={false}
        />
        { this.props.meta.touched && this.props.meta.error && <p className="small error">{ this.props.meta.error }</p> }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/form-input-select/index.js
 **/